var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-404"},[_c('h1',[_vm._v("404")]),_c('p',[_vm._v("Die Seite konnte nicht gefunden werden.")])])
}]

export { render, staticRenderFns }